import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlShortenerService } from '../../../services/url-shortener.service';

@Component({
  selector: 'app-url-redirect',
  template: '<div style="text-align: center; padding: 20px;">Redirecting...</div>',
  styles: []
})
export class UrlRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private urlShortenerService: UrlShortenerService
  ) { }

  ngOnInit(): void {
    // Get the short code from the route
    this.route.params.subscribe(params => {
      const shortCode = params['code'];
      
      if (shortCode) {
        // Get the full URL from the shortener service
        const fullUrl = this.urlShortenerService.getFullUrl(shortCode);
        
        if (fullUrl) {
          // Extract the query parameters from the full URL
          const url = new URL(fullUrl);
          const queryParams = url.search;
          
          // Redirect to the pricing calculator with the parameters
          this.router.navigate(['/pricing-calculator'], { 
            queryParams: this.parseQueryParams(queryParams) 
          });
        } else {
          // If the short code doesn't exist, redirect to error page
          this.router.navigate(['/error']);
        }
      } else {
        // If no short code is provided, redirect to error page
        this.router.navigate(['/error']);
      }
    });
  }

  // Helper function to parse query parameters from a string
  private parseQueryParams(queryString: string): any {
    const params: any = {};
    if (queryString && queryString.startsWith('?')) {
      const urlParams = new URLSearchParams(queryString);
      
      // Use forEach to iterate over URL parameters
      urlParams.forEach((value, key) => {
        params[key] = value;
      });
    }
    return params;
  }
}